import { AxiosRequestConfig } from 'axios';
import { isBrowser } from './browserHelper';
import { getNativeAccessToken } from './cookieHelper';
import { isNativeApp } from './nativeAppHelper';
import { services } from '../context';
import { ConfirmAppointmentParams } from '../services/Appointment/model';

const authTokenHandler = () => {
  const applyBearerToken = (token: string): AxiosRequestConfig => ({
    headers: { Authorization: `Bearer ${token}` },
  });

  const buildAuthConfig = async (): Promise<AxiosRequestConfig> => {
    if (!isBrowser()) return {};

    if (isNativeApp()) {
      const token = getNativeAccessToken();
      return applyBearerToken(token);
    }

    const isLoggedIn = window?.ikea?.authentication?.isLoggedIn;
    if (!isLoggedIn) return {};
    const payload = await isLoggedIn();
    if (!payload.isLoggedIn) return {};
    return applyBearerToken(payload.authToken);
  };

  const getUserInformation = async (): Promise<
    ReturnType<typeof services.user.getUserInformation>
  > => {
    const authConfig = await buildAuthConfig();
    return services.user.getUserInformation(authConfig);
  };

  const confirmAppointment = async (
    params: ConfirmAppointmentParams,
  ): Promise<ReturnType<typeof services.appointment.confirmAppointment>> => {
    const authConfig = await buildAuthConfig();
    return services.appointment.confirmAppointment(params, authConfig);
  };

  return { getUserInformation, confirmAppointment };
};

export const authTokenHandlerInstance = authTokenHandler();
